export const FETCH_SHARED_EVENT_DATA_REQUEST =
  "@shared_event/fetch_data_request";
export const FETCH_SHARED_EVENT_DATA_SUCCESS =
  "@shared_event/fetch_data_success";
export const FETCH_SHARED_EVENT_DATA_FAILURE =
  "@shared_event/fetch_data_failure";
